// @flow

import type {Effect} from '../../types'

import {
  take,
  call,
  put,
  select,
  all,
} from 'redux-saga/effects'
import {
  actionTypes as routerTypes,
} from 'redux-router5'

import {ensureMapReady} from '../../map/effects/ensureMapReady'
import {mapSelectors} from '../../map/selectors'
import {hospitalActions} from '../actions'
import {fetchCities} from '../../map/lib/fetchCities'
import {fetchDistricts} from '../../map/lib/fetchDistricts'

export function* enterAddHospitalEffect(): Effect {
  while (true) {
    const {payload: {route}} = yield take(routerTypes.TRANSITION_SUCCESS)
    if (route.name === 'add-hospital') {
      yield call(ensureMapReady)
      const apiIndex:ApiIndex<MapApi> = yield select(mapSelectors.getApiIndex)
      const {cities, districts} = yield all({
        cities: call(fetchCities, apiIndex),
        districts: call(fetchDistricts, apiIndex),
      })
      yield put(hospitalActions.setSelectedCity(cities[0]._links.self))
      yield put(hospitalActions.setCities(cities))
      yield put(hospitalActions.setDistricts(districts))
    }
  }
}
